<template>
  <div class="page">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">{{ (isCSCproduct ? 'Cscproducts' : (isCSC ? 'Cscs' : 'Etickets')) | lang }} </div>
      <button @click="goTo('/cart', false, true)" :aria-label="dictValue('CartWithItems', {nitems: cartLength})">
        <i class="fa fa-fw fa-shopping-cart" :badge="cartLengthLabel"></i>
      </button>
    </header>

    <!--<stepper :steps="steps" :step="step"  />-->
    <div class="noheader">
      <div class="flexcentered bigger" v-if="loading"><i class="fa fa-fw fa-refresh fa-spin"></i></div>
      <ul class="results-with-icon large" v-else-if="articles.length && isMobile">
        <li v-for="(prod, idx) in articles" :key="idx" @click="choose(prod)" tabindex="0" @keypress.space="choose(prod)" role="button">
          <div>
            <div class="title">
              <span>{{prod.TitleProduct}}</span>
              <span v-if="prod.ItemCategory === 'recharge'"> ({{ 'Recharge' | lang}})</span>
              <span v-else-if="prod.ItemCategory === 'renewal'"> ({{ 'Renewal' | lang}})</span>
            </div>
            <div class="subtitle">{{prod.Title}}</div>
            <div class="subtitle" v-if="prod.RenewalDetail">{{prod.RenewalDetail}}</div>
            <div class="subtitle" v-else>{{prod.TitleNetwork}}</div>
          </div>
          <div>
            <button @click.stop="openInfos(prod)" :aria-label="dictValue('MoreInfos')">
              <i class="fa fa fa-refresh fa-spin" v-if="isLoadingProductId === prod.Id && isLoadingProductIndex === prod.n_Index"></i>
              <i class="fa fa fa-info-circle" v-else></i>
            </button>
          </div>
        </li>
      </ul>
      <ul class="results-with-text large" v-else-if="articles.length && !isMobile">
        <li v-for="(prod, idx) in articles" :key="idx" @click="choose(prod)" tabindex="0" @keypress.space="choose(prod)" role="button">
          <div>
            <div class="title">
              <span>{{prod.TitleProduct}}</span>
              <!-- <span v-if="prod.ItemCategory === 'recharge'"> ({{ 'Recharge' | lang}})</span>
              <span v-else-if="prod.ItemCategory === 'renewal'"> ({{ 'Renewal' | lang}})</span> -->
            </div>
            <div class="subtitle">{{prod.Title}} - {{prod.TitleNetwork}}</div>
          </div>
          <div v-if="prod.ItemCategory === 'recharge'">
            <div class="text-big">{{ 'Recharge' | lang}}</div>
            <div>{{prod.RenewalDetail}}</div>
          </div>
          <div v-else-if="prod.ItemCategory === 'renewal'">
            <div class="text-big">{{ 'Renewal' | lang}}</div>
            <div>{{prod.RenewalDetail}}</div>
          </div>
        </li>
      </ul>
      <div class="flexcentered bigger" v-else>{{ 'NoProducts' | lang }}</div>
    </div>
    <!--<footer>
      <div>
        <button @click="raiseFakeEvent" :disabled="!tag" v-if="tag">Riprova</button>
      </div>
      <div>
        <button @click="confirmRead" :disabled="!tag" v-if="tag">Prosegui</button>
      </div>
    </footer>-->
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
import databaseWrapperMixin from '@/mixins/databaseWrapperMixin'
import saleableServices from '@/mixins/services/saleableServices'
import ProductInfos from '@/dialogs/ProductInfos'
import { create } from 'vue-modal-dialogs'
//import Stepper from '@/components/Stepper.vue';
const ProductInfosDialogCreator = create(ProductInfos)

export default {
  name: 'ProductArticles',
  mixins: [ page, databaseWrapperMixin, saleableServices ],
   //components: { Stepper },
  props: ['type', 'productId'],
  data () {
    return {
    /*  steps:[],
      step:-1,*/
      articles: [],
      lastPromise: null,
      loading: false,
      isLoadingProductId: null,
      isLoadingProductIndex: null // WARN: nobody reset this, it's a sort of "cache" of last index loaded. For know if it's loading use isLoadingProductId instead
    }
  },
  computed: {
    isCSCproduct () {
      return this.type === 'csc'
    },
    isEticket () {
      return this.type === 'eticket'
    },
    isCSC () {
      return this.type === 'newcsc'
    },
    renewal () {
      return this.articles.filter(art => art.ItemCategory === 'renewal')
    },
    recharge () {
      return this.articles.filter(art => art.ItemCategory === 'recharge')
    },
    newBoughts () {
      return this.articles.filter(art => art.ItemCategory === 'loading')
    }
  },
  methods: {
    openInfos (prod) {
      ProductInfosDialogCreator({ prod })
    },
    choose (prod) {
      this.isLoadingProductId = prod.Id
      this.isLoadingProductIndex = prod.n_Index
      this.buying = {
        csc: this.buying && this.buying.csc ? this.buying.csc : {},
        pagecount: this.buying ? this.buying.pagecount : 0
      }
      let p = { itemId: prod.Id, mediaType: 'Eticket', index: prod.n_Index }
      if (this.isCSCproduct) {
        p.mediaType = 'TransportProduct'
        p.mediaSerialNumber = this.buying.csc.MediaSerialNumber
        p.mediaUnicity = this.buying.csc.MediaUnicity
        p.index = 0
      } else if (this.isCSC) {
        p.mediaType = 'Csc'
      }
      let promise = this._getSaleableItem(p)
      this.lastPromise = promise
      promise.then(data => {
        if (this.lastPromise === promise) {
          this.isLoadingProductId = null
          this.buying = {
            csc: this.isCSCproduct ? this.buying.csc : null,
            toBeAsked: data.ApisToCall.slice().concat(['end']),
            ticketInfo: data,
            askPrice: data.ApisToCall.indexOf('price') > -1,
            pagecount: this.buying ? this.buying.pagecount : 0
            // EvidenceInfo: data.EvidenceInfo
          }
          console.log(this.buying.toBeAsked)
          this.goTo('/products/' + this.type + '/' + this.productId + '/' + prod.Id + '/' + this.buying.toBeAsked[0], false)
        }
      }).catch(e => {
        if (this.lastPromise == promise) {
          this.isLoadingProductId = null
          console.log(e)
          this.internalBus.$emit('notify:error', {
            text: this.dictValue('errorOccured') + (e.status === 418 ? '[VAD]' : ''),
            key: this.notifierKey,
            timeout: 3000
          })
          this.back()
        }
      })
    }
  },
  beforeDestroy () {},
  mounted () {
    this.buying = this.buying || { csc: null }
    if (!this.buying) {
      this.back() // this.goTo('/products/new', true)
    } else {
      this.articles.splice(0, this.articles.length)
      let p
      if (this.isCSCproduct) {
        p = this._getSaleableProductsOnCSC({ mediaUnicity: this.buying.csc.MediaUnicity, mediaSerialNumber: this.buying.csc.MediaSerialNumber })
       
      } else if (this.isEticket) {
        p = this._getSaleableProducts({ productTypes: 'MediaProduct'})
      } else {
        p = this._getSaleableProductsCSC({ productTypes: 'AdditionnalProduct', mediaSerialNumber: null, mediaUnicity: null })
      /*  this.steps=[
        "Selezione Tessera" ,
        "Caricamento Documenti",
        "Scelta Spedizione" ,
        "Conferma ordine"
      ]
      this.step=0;*/
      }
      this.lastPromise = p
      this.loading = true
      p.then(data => {
        if (this.lastPromise == p) {
          // console.log('data', data)
          this.articles.splice(0, this.articles.length, ...data)
        }
        this.loading = false
      }).catch(e => {
        console.log('this.lastPromise == p', this.lastPromise == p)
        if (this.lastPromise == p) {
          console.log(e)
          this.internalBus.$emit('notify:error', {
            text: this.dictValue('errorOccured') + (e.status === 418 ? '[VAD]' : ''),
            key: 'productarticleslist', // this.notifierKey,
            timeout: 3000
          })
          this.back()
        }
      })
    }
  },
  watch: {}
}
</script>

<style></style>
